import React from 'react';
import { Form, Input, Select } from 'antd';

const { Option } = Select;

const StudentForm = ({ form, isEditMode = false, classes = [] }) => {
  return (
    <Form form={form} layout="vertical" name="student_form">
      <Form.Item
        name="name"
        label="姓名"
        rules={[{ required: true, message: '请输入学员姓名!' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="account"
        label="账号"
        rules={[{ required: true, message: '请输入学员账号!' }]}
      >
        <Input />
      </Form.Item>
      {!isEditMode && (
        <Form.Item
          name="password"
          label="初始密码"
          rules={[{ required: true, message: '请输入初始密码!' }]}
        >
          <Input.Password />
        </Form.Item>
      )}
      <Form.Item
        name="classId"
        label="班级"
        rules={[{ required: true, message: '请选择班级!' }]}
      >
        <Select placeholder="请选择班级" aria-label="选择班级">
          {classes.map(cls => (
            <Option key={cls.id} value={cls.id}>{cls.name}</Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        name="major"
        label="专业"
      >
        <Input />
      </Form.Item>
      <Form.Item name="school" label="学校">
        <Input />
      </Form.Item>
      <Form.Item name="gender" label="性别">
        <Select placeholder="请选择性别" allowClear>
          <Option value="男">男</Option>
          <Option value="女">女</Option>
        </Select>
      </Form.Item>
      <Form.Item name="building" label="楼栋">
        <Input />
      </Form.Item>
      <Form.Item name="dormitoryNumber" label="寝室号">
        <Input />
      </Form.Item>
      <Form.Item name="bedNumber" label="床位号">
        <Input />
      </Form.Item>
      <Form.Item
        name="classMode"
        label="上课方式"
      >
        <Select placeholder="请选择上课方式" allowClear aria-label="选择上课方式">
          <Option value="住宿">住宿</Option>
          <Option value="走读">走读</Option>
        </Select>
      </Form.Item>
      <Form.Item
        name="role"
        label="角色"
        initialValue="STUDENT"
        hidden
      >
        <Input />
      </Form.Item>
    </Form>
  );
};

export default StudentForm;
